export const HeaderLoading = () => {
  const renderHeader = () => {
    return (
      <div className="flex h-24 animate-pulse flex-col items-center gap-2 rounded-2xl border bg-gray-200 p-5">
        <div className="h-6 w-full rounded-full bg-gray-400" />
        <div className="size-8 rounded-full bg-gray-400" />
      </div>
    );
  };

  return (
    <div className=" grid grid-cols-1 flex-wrap gap-4 md:grid-cols-2 lg:grid-cols-4">
      {renderHeader()}
      {renderHeader()}
      {renderHeader()}
      {renderHeader()}
    </div>
  );
};
